import React, { useContext } from 'react'
import Order from 'components/Order/'
import { Grid, Typography } from '@material-ui/core'
import styles from 'assets/jss/views/orderDetailPage.js'
import { makeStyles } from '@material-ui/core/styles'
import Context from 'context/Context'
import ThumbUp from 'assets/img/vmove/icons/thumb_up.svg'
import { useMediaQuery } from 'react-responsive'

const useStyles = makeStyles(styles)

const SuccessOrderState = () => {
  const classes = useStyles()
  const isMobile = useMediaQuery({ query: '(max-width: 959px)' })

  const contextType = useContext(Context)
  const { t } = contextType

  return (
    <Grid container spacing={2} className={classes.gridContainer}>
      <Grid item xs={12} sm={12}>
        <img alt='Thumb Up' src={ThumbUp} className={classes.imageIcon} />
      </Grid>
      <Grid item xs={12} sm={12} className={classes.mb25}>
        <Typography align={'center'} variant='h3' className={isMobile ? classes.titleMobile : classes.title}>
          {t('payment_info')}
        </Typography>
        <Typography align={'center'} className={isMobile ? classes.subTitleMobile : classes.subTitle}>
          {t('successfully')}
        </Typography>
        <Typography align={'center'} className={isMobile ? classes.bodyMobile : classes.body}>
          {t('payment_success_1')}
        </Typography>
        <Typography align={'center'} className={isMobile ? classes.bodyMobile : classes.body}>
          {t('payment_success_2')}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default SuccessOrderState
